import { lazy } from 'react';

const ContactUs = lazy(() => import('../ContactUs'));
const Memorial = lazy(() => import('../Memorial'));
const ConfirmAccount = lazy(() => import('../ConfirmAccount'));
const AnimalsInHeaven = lazy(() => import('../AnimalsInHeaven'));
const AddMemorial = lazy(() => import('../AddMemorial'));
const Mission = lazy(() => import('../Mission'));
const AdoptionCenterForm = lazy(() => import('../AdoptionCenterForm'));
const AdoptionCenter = lazy(() => import('../AdoptionCenter'));
const AnimalForAdoption = lazy(() => import('../AnimalForAdoption'));
const AnimalsForAdoption = lazy(() => import('../AnimalsForAdoption'));
const Account = lazy(() => import('../Account'));
const MyMemorials = lazy(() => import('../MyMemorials'));
const MyAdoptionCenter = lazy(() => import('../MyAdoptionCenter'));
const AnimalForAdoptionForm = lazy(() => import('../AnimalForAdoptionForm'));
const MyAnimalsForAdoption = lazy(() => import('../MyAnimalsForAdoption'));
const AdoptionCenters = lazy(() => import('../AdoptionCenters'));
const PageNotFound = lazy(() => import('../PageNotFound'));
const Admin = lazy(() => import('../Admin'));
const Terms = lazy(() => import('../Terms'));
const LastAnimalsInHeaven = lazy(() => import('../LastAnimalsInHeaven'));

export interface RouteType {
  path: string;
  Component: React.ComponentType<any>;
  isProtected?: boolean;
}

const routes: RouteType[] = [
  {
    path: '/contact-us',
    Component: ContactUs,
  },
  {
    path: '/memorial/:id',
    Component: Memorial,
  },
  {
    path: '/confirm-account/:id',
    Component: ConfirmAccount,
  },
  {
    path: '/animals-in-heaven',
    Component: AnimalsInHeaven,
  },
  {
    path: '/add-memorial/:id?',
    Component: AddMemorial,
  },
  {
    path: '/mission',
    Component: Mission,
  },
  {
    path: '/my-adoption-center/:mode',
    Component: AdoptionCenterForm,
  },
  {
    path: '/adoption-center/:id',
    Component: AdoptionCenter,
  },
  {
    path: '/animal-for-adoption/:id',
    Component: AnimalForAdoption,
  },
  {
    path: '/animals-for-adoption',
    Component: AnimalsForAdoption,
  },
  {
    path: '/account',
    Component: Account,
    isProtected: true,
  },
  {
    path: '/my-memorials',
    Component: MyMemorials,
    isProtected: true,
  },
  {
    path: '/view-my-adoption-center',
    Component: MyAdoptionCenter,
    isProtected: true,
  },
  {
    path: '/animal-adoption-form/:id?',
    Component: AnimalForAdoptionForm,
    isProtected: true,
  },
  {
    path: '/my-animals-for-adoption',
    Component: MyAnimalsForAdoption,
    isProtected: true,
  },
  {
    path: '/adoption-centers',
    Component: AdoptionCenters,
  },
  {
    path: '/admin',
    Component: Admin,
    isProtected: true,
  },
  {
    path: 'terms',
    Component: Terms,
  },
  {
    path: '/last-animals-in-heaven',
    Component: LastAnimalsInHeaven,
  },
  {
    path: '*',
    Component: PageNotFound,
  },
];

export default routes;
